// src/pages/ConsultationSpecialPage.js (MIGRADO A REACT ROUTER)

import React from 'react';
// ✅ Importamos useNavigate
import { useNavigate } from 'react-router-dom'; 
import { FaArrowLeft, FaLightbulb } from 'react-icons/fa';
import PaymentDetails from '../components/PaymentDetails';
import './ConsultationPage.css'; 

// 🛑 ELIMINAMOS setActivePage de las props
const ConsultationSpecialPage = () => {
    const navigate = useNavigate(); // ✅ Inicializamos useNavigate
    const serviceName = "Estrategia y Análisis Especializado";
    const price = "Precio a Convenir"; // Indicamos que el precio no es fijo

    return (
        <div className="page-container consultation-payment-page">
            
            <div className="service-header">
                <FaLightbulb className="service-icon-large" />
                <h1>Adquiere: {serviceName}</h1>
                <h2 className="service-price-tag">Consulte Precio</h2>
                <p className="service-description">
                    Diseñada para casos jurídicos complejos, litigios o para el desarrollo de una estrategia empresarial exhaustiva. Es necesaria una evaluación previa para determinar el alcance y el precio.
                </p>
            </div>
            
            {/* Usamos el componente de pago para dirigir al cliente a contactar */}
            <PaymentDetails 
                price={price} 
                serviceName={serviceName}
            />

            {/* 🚀 BOTÓN "Volver a Servicios" CORREGIDO */}
            <button className="back-button" onClick={() => navigate('/servicios')}>
                <FaArrowLeft /> Volver a Servicios
            </button>
        </div>
    );
};

export default ConsultationSpecialPage;